import { render } from "./CouponItem.vue?vue&type=template&id=c9917a6a&scoped=true"
import script from "./CouponItem.vue?vue&type=script&lang=js"
export * from "./CouponItem.vue?vue&type=script&lang=js"

import "./CouponItem.vue?vue&type=style&index=0&id=c9917a6a&lang=scss&scoped=true"

import exportComponent from "/Users/opm/opm-vue-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9917a6a"]])

export default __exports__